module.exports = {
  extra: true
};



//////////////////
// WEBPACK FOOTER
// ./opts.js
// module id = 3
// module chunks = 0